
import { defineComponent, ref, inject, computed, provide, nextTick } from 'vue'
import FormService from '@/core/services/FormService'
import { errManager, DownloadFile, mbtoa, showNotification } from "@/core/config/Tools";
import type { TableInstance } from 'element-plus'
import DialogForms from '@/views/tournaments/pages/DialogForms.vue';
import { useI18n } from "vue-i18n/index";
import Swal from 'sweetalert2';
import GlobalService from '@/core/services/GlobalService';
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
    name: "acrd-dialog-list-clubs",
    props: {
        listStatus: {
            type: null,
            required: true,
            default: []
        },
        itemForm: {
            type: null,
            required: true,
            default: {}
        }
    },
    components: { DialogForms },
    setup(props) {
        const { t } = useI18n();
        const store = useStore();
        const altura = screen.height;
        const loading = ref(false);
        const dialogListClubs = inject("dialogListClubs");
        const search = ref("");
        const listInstitutions = ref<any>([]);
        const listSports = ref<any>([]);
        const dialogForm = ref(false);
        const idinstitution = ref<any>("");
        const REPO = ref<any>(process.env.VUE_APP_REPO);
        //const selectedRowId = ref<number | null>(null);
        const indexRow = ref(0);
        const singleTableRef = ref<TableInstance>()

        provide("dialogForm", dialogForm)
        provide("idinstitution", idinstitution)

        const getListInstitutions = async () => {
            store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
            await FormService.options('institutions', props.itemForm)
                .then(async (res) => {
                    listInstitutions.value = res.data.clubs;
                    listSports.value = res.data.sports;
                    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");

                    await nextTick();

                    const row = listInstitutions.value[indexRow.value];
                    if (row) {
                        singleTableRef.value?.setCurrentRow(row);
                    }
                }).catch(({ response }) => {
                    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
                    errManager(response)
                })
        }

        // Función para verificar si el deporte está en la lista de seleccionados
        const isSelected = (idsport: any, list: any[]): boolean => {
            return list.some(selected => selected.idsport === idsport);
        };

        const filteredClubs = computed(() => {
            const query = search.value.toLowerCase();
            return listInstitutions.value.filter(
                item => {
                    const abrevMatches = item.abrev ? item.abrev.toLowerCase().includes(query) : false;
                    const businessMatches = item.business.toLowerCase().includes(query);
                    return abrevMatches || businessMatches;
                }
            );
        });

        const calculateTotal = (sports: any[]) => {
            return sports.length;
        };

        const handlerDeleteRecord = (row: any) => {
            Swal.fire({
                title: t('deleteRecord'),
                html: t('deleteText', {text: row?.business }),
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: t('delete'),
                cancelButtonText: t('cancel'),
                reverseButtons: true,
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: 'btn btn-sm bg-danger', // Rojo para eliminar
                    cancelButton: 'btn btn-sm bg-secondary text-black' // Gris para cancelar
                },
                preConfirm: () => {
                    return GlobalService.delete('forms', `${props.itemForm?.idform}/${row.id}`)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response.data}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    showNotification({ status: result.value.status, title: result.value.title, message: result.value.message })
                    result.value.status === 'success' && getListInstitutions();
                }
            })
        }

        const onOpened = () => {
            getListInstitutions();
        }

        const onClosed = () => {
            listInstitutions.value = []
            listSports.value = []
        }

        const openDialogForm = (data, index) => {
            dialogForm.value = true;
            idinstitution.value = data;
            indexRow.value = index;
        }

        const modalClosed = () => {
            getListInstitutions()
        }

        return {
            t,
            altura,
            loading,
            dialogListClubs,
            search,
            listInstitutions,
            listSports,
            REPO,
            singleTableRef,
            //events
            onOpened,
            onClosed,
            isSelected,
            filteredClubs,
            openDialogForm,
            modalClosed,
            DownloadFile,
            mbtoa,
            calculateTotal,
            handlerDeleteRecord,
            getListInstitutions
        }

    },
})
